import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import NavibarStore from '@src/business-components/navibar/store';
import AdvantageStore from '@src/business-components/advantage-page/store';
import ProjectStore from '@src/business-components/project-page/store';
import SupplierStore from '@src/business-components/supplier-page/store';
import JoinStore from '@src/business-components/join-page/store';
import FooterStore from '@src/business-components/footer-page/store';
import KvBoxStore from '@src/business-components/kv-box/store';

class MainStore extends BaseStore {
  navibarStore = new NavibarStore({ mainStore: this });
  kvBoxStore = new KvBoxStore({
    // redirectLink: () => {
    //   this.redirectLink();
    // }
  });
  advantageStore = new AdvantageStore();
  projectStore = new ProjectStore();
  supplierStore = new SupplierStore();
  joinStore = new JoinStore();
  footerStore = new FooterStore();

  // redirectLink = () => {
  //   this.navibarStore.scrollToAnchor('project');
  // };

  use() {
    super.use();
    useMount(async () => {
      console.log('componentDidMount');
    });
  }
}

export default MainStore;
